import type { GetPropertyCoveragesResponse } from '@/shared/types';

import { apiUri } from '@/constants/Constants';
import { DealsDashboardClient } from '@/shared/api';

export type GetPropertyCoveragesParams = {
  lease_start_date?: string;
  lease_end_date?: string;
  gross_monthly_rent?: number;
  prepaid_rent?: number;
  free_rent?: number;
};

export const getPropertyCoverages = async (
  propertyId: string,
  params?: GetPropertyCoveragesParams,
) => {
  const response = await DealsDashboardClient.get<GetPropertyCoveragesResponse>(
    apiUri.getPropertyCoverages.replace('{propertyId}', propertyId),
    {
      params,
    },
  );
  return response.data?.data?.coverage_rules ?? [];
};
